import { render } from "./HomePageTemplate.vue?vue&type=template&id=674e49a6"
import script from "./HomePageTemplate.vue?vue&type=script&lang=js"
export * from "./HomePageTemplate.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__